import React, { FunctionComponent } from 'react';
import type { CompanyPostsProps } from './types';
import { Post } from '../../../types/posts';
import { Paginate } from '../../molecules/paginate';
import { CompanyPostCard } from '../../molecules/companyPostCard';

type Props = CompanyPostsProps & {
  paginate_per: number;
  currentPage: number;
  shouldShowPagination: boolean;
  paginatedPosts: Post[];
  onPageChange: (newPage: number) => void
};

export const Presentation: FunctionComponent<Props> = ({
  companyId,
  companyName,
  posts,
  paginate_per,
  currentPage,
  shouldShowPagination,
  paginatedPosts,
  onPageChange
}) => {
  return (
   <div className="l-articles js-background-fixed">
      <div className="l-articles-inner u-clear">
        <h1 className="articles-title articles-title-story">
          {companyName}のストーリー一覧
        </h1>

        {paginatedPosts.length > 0 ? (
          <main className="l-articles-main l-articles-main--story">
            <div className="articles-list">
              <ul className="articles-list-inner">
                {paginatedPosts.map((post) => (
                  <CompanyPostCard
                    key={post.id}
                    post={post}
                    companyId={companyId}
                  />
                ))}
              </ul>
            </div>
          </main>
        ) : (
          <main className="l-articles-main--story empty">
            <h3 className="title">ストーリーはまだありません</h3>
            <div className="contents">
              <p>企業をフォローするとストーリーが公開されたタイミングで通知が届きます。</p>
              <p>最新の情報を見逃したくない場合はフォローしてください。</p>
            </div>
          </main>
        )}

        {shouldShowPagination && (
          <Paginate
            current={currentPage}
            max={Math.ceil(posts.length / paginate_per)}
            page="posts"
            handleClick={(page: number) => onPageChange(page)}
          />
        )}
      </div>
    </div>
  );
};
